export default __webpack_public_path__ + "static/media/mb-cross.6f6867ba.svg";